import { render } from "./tagSoldOut.vue?vue&type=template&id=5d5a3f08"
import script from "./tagSoldOut.vue?vue&type=script&lang=js"
export * from "./tagSoldOut.vue?vue&type=script&lang=js"

import "./tagSoldOut.vue?vue&type=style&index=0&id=5d5a3f08&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__